// 报表中心
export default {
  // batchInsertWmsStorageByPub: (params) => $network.post('/api/cs/sg/batchInsertWmsStorageByPub', params),
  batchInsertWmsStorageByPub: (params) => $network.post('/api/cs/sg/recheckInventory', params),
  batchInsertSapStorageByPub: (params) => $network.post('/api/cs/sg/batchInsertSapStorageByPub', params),
  consignmentStorage: (params) => $network.post('/api/cs/sg/consignment/storage', params),
  rcOrderReportExportApiObj: () => {
    const obj = {
      RETURN_ORDER_EXPORTVIEW: {
        table: 'RETURN_ORDER_EXPORTVIEW',
        url: '/api/cs/rc/exportReturnOrder',
        filename: '退换货单导出报表',
        menu: '退换货单导出报表',
        type: ''
      },
      V_OC_B_VIPCOM_DISTRIBUTION: {
        table: 'V_OC_B_VIPCOM_DISTRIBUTION',
        url: '/api/cs/rc/exportVipcomDistribution',
        filename: '配货单导出报表',
        menu: '配货单导出报表',
        type: ''
      },
      ORDEREXPORTVIEW: {
        table: 'ORDEREXPORTVIEW',
        url: '/api/cs/rc/exportOrderReport',
        filename: '订单导出报表',
        menu: '订单导出报表'
      },
      V_SG_B_PHY_OUT_NOTICES: {
        table: 'V_SG_B_PHY_OUT_NOTICES',
        url: '/api/cs/rc/exportPhyOutNoticesReport',
        filename: '出库通知单导出报表',
        menu: '出库通知单导出报表',
        type: ''
      },
      REFUND_IN_EXPORTVIEW: {
        table: 'REFUND_IN_EXPORTVIEW',
        url: '/api/cs/rc/exportRefIn',
        filename: '退货入库导出报表',
        menu: '退货入库导出报表'
      },
      V_RETAIL_REPORT: {
        table: 'V_RETAIL_REPORT',
        url: '/api/cs/rc/exportRetailReport',
        filename: '零售导出报表',
        menu: '零售导出报表'
      }
    };
    return obj;
  },
};
